<template>
  <div>
    <v-layout pt-12></v-layout>
    <v-layout pt-12></v-layout>
    <v-layout wrap pt-12 justify-center>
      <v-flex xs12 md2 align="center">
        <v-img src="../../assets/icons/tick.png" aspect-ratio="1" contain height="50px">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 md12 text-center>
        <span style="font-size:18px;color:#000;font-weight:400">Login Successfull</span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 md12 text-center>
        <span style="font-size:14px;font-weight:400;color:#a9a9a9;">{{loginData.mailId}}</span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 md3 align="center">
        <v-img src="../../assets/person.png" contain height="300px">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["loginData"],
  data() {
    return {};
  },
  beforeMount() {
    this.submit();
  },
  methods: {
    submit() {
      if (this.loginData.progress < 100) {
        localStorage.setItem("email", this.loginData.mailId);
        localStorage.setItem("userId", this.loginData.userId);
        setTimeout(() => {
          // this.$emit("stepper", { winStep: 1 });
          if (this.loginData.profilestep == 0) {
            this.$router.push("/CompleteProfile");
          }
          if (this.loginData.profilestep == 1) {
            this.$router.push("/DocumentsUpload");
          }
          if (this.loginData.profilestep == 2) {
            this.$router.push("/registrationAcknowledgement");
          }
        }, 1000);
      } else {
        this.$router.push("/");
      }
    }
  }
};
</script>